import React, { useContext } from "react";

import { observer } from "mobx-react";
import { Switch, List, Card, Skeleton, notification, message } from "antd";
import { toJS } from "mobx";
import PermissionStore from "../store/permissionStore";
import { Typography } from "antd";

import { AppstoreAddOutlined } from "@ant-design/icons";
import { getAntIconEquivalent } from "../../../../Utility/modules/helpers";
const { Text, Title } = Typography;
export const Permission = observer((props) => {
  const permissionStore = useContext(PermissionStore);
  const handleChange = async (val, type, rec) => {
    const row = toJS(rec);
    row[type] = val;
    try {
      await permissionStore.updatePermission(row);
      message.success("Modification sucessfull");
    } catch (error) {
      notification.open({
        message: "Feedback Manager",
        type: "error",

        description: `Something went wrong.${error.message}.`,
      });
    }
  };
  return (
    <>
      {!permissionStore.isLoadinggrouppermissions ? (
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <List
                grid={{
                  gutter: 16,
                  xs: 1,
                  sm: 2,
                  md: 4,
                  lg: 4,
                  xl: 6,
                  xxl: 3,
                }}
                header={
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm12">
                        {" "}
                        <Title
                          level={4}
                          style={{
                            display: "inline-block",
                            marginRight: "5px",
                            fontSize: "16px",
                            color: "red",
                          }}
                        >
                          <AppstoreAddOutlined style={{ color: "#FAAD14" }} />{" "}
                          {permissionStore.selectedRole?.name
                            ? permissionStore.selectedRole?.name +
                              " Permissions"
                            : ""}
                        </Title>
                      </div>
                    </div>
                  </div>
                }
                dataSource={[...permissionStore.permissions.values()]}
                renderItem={(item) => (
                  <List.Item>
                    <Card
                      title={
                        <div>
                          {getAntIconEquivalent(item.menuIcon)}{" "}
                          <Title
                            level={4}
                            style={{
                              display: "inline",
                              fontSize: "14px",
                            }}
                          >
                            {item.menu}
                          </Title>
                        </div>
                      }
                    >
                      <List
                        itemLayout="vertical"
                        rowKey={(perm) => perm.rowKey}
                        dataSource={item.permissions.map((permission, index) => ({
                          permission,
                          rowKey: `${item.menuId}-${permission.subMenuId}-${index}`,
                        }))}
                        renderItem={({ permission: perm }) => (
                          <List.Item>
                            <List.Item.Meta
                              title={
                                <Text
                                  style={{
                                    color: "#A0AEC0",

                                    fontSize: "14px",
                                  }}
                                >
                                  {perm.name}
                                </Text>
                              }
                            />
                            <div className="ms-Grid" dir="ltr">
                              <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm6">View</div>
                                <div className="ms-Grid-col ms-sm6">
                                  {" "}
                                  <Switch
                                    checkedChildren="Deny"
                                    unCheckedChildren="Grant"
                                    defaultChecked={perm.canView}
                                    onChange={(check, ev, type = "canView") => {
                                      handleChange(check, type, perm);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm6">Modify</div>
                                <div className="ms-Grid-col ms-sm6">
                                  {" "}
                                  <Switch
                                    checkedChildren="Deny"
                                    unCheckedChildren="Grant"
                                    defaultChecked={perm.canUpdate}
                                    onChange={(
                                      check,
                                      ev,
                                      type = "canUpdate"
                                    ) => {
                                      handleChange(check, type, perm);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm6">Remove</div>
                                <div className="ms-Grid-col ms-sm6">
                                  {" "}
                                  <Switch
                                    checkedChildren="Deny"
                                    unCheckedChildren="Grant"
                                    defaultChecked={perm.canDelete}
                                    onChange={(
                                      check,
                                      ev,
                                      type = "canDelete"
                                    ) => {
                                      handleChange(check, type, perm);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm6">
                                  Execute
                                </div>
                                <div className="ms-Grid-col ms-sm6">
                                  {" "}
                                  <Switch
                                    checkedChildren="Deny"
                                    unCheckedChildren="Grant"
                                    defaultChecked={perm.canExecute}
                                    onChange={(
                                      check,
                                      ev,
                                      type = "canExecute"
                                    ) => {
                                      handleChange(check, type, perm);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm6">
                                  Approve
                                </div>
                                <div className="ms-Grid-col ms-sm6">
                                  {" "}
                                  <Switch
                                    checkedChildren="Deny"
                                    unCheckedChildren="Grant"
                                    defaultChecked={perm.canApprove}
                                    onChange={(
                                      check,
                                      ev,
                                      type = "canApprove"
                                    ) => {
                                      handleChange(check, type, perm);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="ms-Grid" dir="ltr">
                              <div className="ms-Grid-row">
                                <div
                                  className="ms-Grid-col ms-sm12 ms-fontSize-12"
                                  style={{
                                    paddingTop: "5px",
                                    color: "#CBD5E0",
                                  }}
                                >
                                  {perm.display}
                                </div>
                              </div>
                            </div>
                          </List.Item>
                        )}
                      />
                    </Card>
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      )}
    </>
  );
});

